


















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { TipStatisticItem } from "@scrile/api-provider/dist/api/TipProvider";
import { formatMoneyString } from "@/lib/moneyHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import FormatMoney from "@/components/FormatMoney";
import ListItem from "@/components/ListItem";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "TippedUsersList",
  components: { BaseSpinner, FormatMoney, BaseInput, CustomScroll, BaseAvatar, ListItem, PageTitle },
  props: {
    totalAmount: { type: Number, default: 0 },
    statItems: { type: Array as () => TipStatisticItem[], required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props) {
    const term = ref("");
    const filterLoading = ref(false);

    const filteredItemList = computed<TipStatisticItem[]>(() =>
      props.statItems.filter(item => {
        if (!term.value.trim()) return true;
        return item.user.screenName.includes(term.value);
      })
    );
    const setTerm = async (termValue: string) => {
      term.value = termValue;
    };
    return {
      term,
      filterLoading,
      filteredItemList,
      setTerm,
      formatMoneyString,
    };
  },
});
